(function () {
  "use strict";

  var STORAGE_TOKEN = "bp_attribution_token";
  var STORAGE_CAMPAIGN = "bp_campaign";
  var URL_TOKEN = "bp_attribution";
  var URL_CAMPAIGN = "bp_campaign";
  var ATTR_TOKEN = "attribution_token";
  var ATTR_CAMPAIGN = "campaign";

  var pending = null;
  var lastApplied = null;
  var debounceTimer = null;

  function cartRoot() {
    if (
      window.Shopify
      && window.Shopify.routes
      && window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return "/";
  }

  function readUrlValues() {
    var params = new URLSearchParams(window.location.search);

    return {
      token: params.get(URL_TOKEN),
      campaign: params.get(URL_CAMPAIGN),
    };
  }

  function readStoredValues() {
    try {
      return {
        token: sessionStorage.getItem(STORAGE_TOKEN),
        campaign: sessionStorage.getItem(STORAGE_CAMPAIGN),
      };
    } catch (error) {
      return {
        token: null,
        campaign: null,
      };
    }
  }

  function writeStoredValues(token, campaign) {
    try {
      if (token) {
        sessionStorage.setItem(STORAGE_TOKEN, token);
      }

      if (campaign) {
        sessionStorage.setItem(STORAGE_CAMPAIGN, campaign);
      }
    } catch (error) {
      /* ignore private mode / blocked storage */
    }
  }

  function resolveValues() {
    var fromUrl = readUrlValues();

    if (fromUrl.token) {
      writeStoredValues(fromUrl.token, fromUrl.campaign);
    }

    var stored = readStoredValues();

    return {
      token: fromUrl.token || stored.token,
      campaign: fromUrl.campaign || stored.campaign || "",
    };
  }

  function signature(token, campaign) {
    return String(token || "") + "\0" + String(campaign || "");
  }

  function applyAttributes(force) {
    var values = resolveValues();

    if (!values.token) {
      return Promise.resolve();
    }

    var sig = signature(values.token, values.campaign);

    if (!force && sig === lastApplied) {
      return Promise.resolve();
    }

    if (pending) {
      return pending;
    }

    var payload = {
      attributes: {},
    };
    payload.attributes[ATTR_TOKEN] = values.token;
    payload.attributes[ATTR_CAMPAIGN] = values.campaign;

    pending = fetch(cartRoot() + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        if (!response.ok) {
          return null;
        }

        return response.json();
      })
      .then(function (cart) {
        if (cart) {
          lastApplied = sig;
        }
      })
      .catch(function () {
        /* fail silently; next navigation can retry */
      })
      .finally(function () {
        pending = null;
      });

    return pending;
  }

  function scheduleApply(force) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      applyAttributes(force);
    }, 200);
  }

  function isCartAddUrl(url) {
    return typeof url === "string" && url.indexOf("/cart/add") !== -1;
  }

  function watchCartAdds() {
    document.addEventListener("submit", function (event) {
      var form = event.target;

      if (
        form
        && form.tagName === "FORM"
        && form.action
        && isCartAddUrl(form.action)
      ) {
        scheduleApply(true);
      }
    });

    document.addEventListener("cart:updated", function () {
      scheduleApply(true);
    });

    document.addEventListener("cart:refresh", function () {
      scheduleApply(true);
    });

    if (!window.fetch) {
      return;
    }

    var nativeFetch = window.fetch;

    window.fetch = function (input, init) {
      var url = typeof input === "string"
        ? input
        : (input && input.url) || "";

      return nativeFetch.apply(this, arguments).then(function (response) {
        if (isCartAddUrl(url) && response.ok) {
          scheduleApply(true);
        }

        return response;
      });
    };
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scheduleApply(false);
    });
  } else {
    scheduleApply(false);
  }

  watchCartAdds();
})();
